// PRD 05 §3.7 + PRD 21 §10 — the post-save modal that reminds the author to
// kick off [PRO 배포] before the change reaches the patient app.

import { useTranslation } from 'react-i18next';

import { InfoModal } from '@/components/feedback/InfoModal';

interface PostSaveDeployNoticeProps {
  open: boolean;
  // The action that just completed — phrases the lead sentence accordingly so
  // the modal reads naturally across create / update / delete / copy.
  action: 'saved' | 'deleted' | 'copied';
  onClose: () => void;
}

const ACTION_KEY: Record<PostSaveDeployNoticeProps['action'], string> = {
  saved: 'deployNotice.saved',
  deleted: 'deployNotice.deleted',
  copied: 'deployNotice.copied',
};

export function PostSaveDeployNotice({ open, action, onClose }: PostSaveDeployNoticeProps) {
  const { t } = useTranslation('questionnaire-design');
  return (
    <InfoModal
      open={open}
      title={t('deployNotice.title')}
      body={
        <>
          {t(ACTION_KEY[action])}{' '}
          <span
            dangerouslySetInnerHTML={{
              __html: t('deployNotice.instructionHtml'),
            }}
          />
        </>
      }
      confirmLabel={t('deployNotice.confirm')}
      onClose={onClose}
    />
  );
}
